import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'ISSUE_LABELS',
    itemActionName: 'ISSUE_LABEL',
});
